// extracted by mini-css-extract-plugin
export default {"container":"ReportError_container__KDmp2","icon":"ReportError_icon__Jwmpf","mobile":"ReportError_mobile__HVpOU","open":"ReportError_open__bxOYV","inner":"ReportError_inner__X-YNx"};